import comp from "./GenericCardList.js";
export default comp;
